module.exports = __webpack_public_path__ + "static/media/animated_nagraj-modified.f0a12cc0.png";